export default __webpack_public_path__ + "static/media/twitter-logo.cbf2aa14.svg";